import * as Yup from 'yup';

export class UpdateCargoTypeValidator {
  public get schema() {
    return Yup.object().shape({
      name: Yup.string().required('Informe o nome do tipo de carga'),
      blockedAt: Yup.string()
        .nullable()
        .transform((value) => {
          if (value === '1') return new Date().toISOString();
          return null;
        }),
    });
  }
}
